import {Component, ViewChild, OnInit} from '@angular/core';
import {NavController, NavParams, LoadingController, ViewController} from 'ionic-angular';

import {GeolocationProvider} from '../../providers/geolocation/geolocation';

@Component({
  selector: 'page-map-modal',
  templateUrl: 'map-modal.html',
})
export class MapModalPage implements OnInit {
  hideMap = true;
  lat: number;
  lng: number;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private geolocationProvider: GeolocationProvider,
    private loadingCtrl: LoadingController,
    private viewCtrl: ViewController,
  ) {}

  ngOnInit() {
    const self = this;
    self.getPosition();
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad MapModalPage');
  }

  dismiss() {
    const self = this;
    self.viewCtrl.dismiss();
    //let data = {
    //  profileImage: self.profileImage,
    //  profileImageUrl: self.profileImageUrl,
    //};
    //self.viewCtrl.dismiss(data);
  }

  getPosition() {
    const self = this;
    let loader = self.loadingCtrl.create({
      content: 'Getting your location...',
    });
    loader.present();
    const options = {
      enableHighAccuracy: true,
      timeout: 5000,
      maximumAge: 0,
    };
    self.geolocationProvider.getLocation(options).subscribe(
      position => {
        console.log(position);
        self.lat = position.coords.latitude;
        self.lng = position.coords.longitude;
        self.hideMap = false;
        loader.dismiss();
      },
      error => {
        // TODO: add error service to push an error alert
        console.log(error);
      },
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/map-modal/map-modal.ts